<rt-interview-base-box
  [question]="questionForm.value"
  [padding]="false"
  [invalid]="questionForm.get('contents')!.invalid && questionForm.touched && formSubmissionAttempt"
  [formGroup]="questionForm"
  [rtProtectedControl]="questionForm.get('contents')"
  [rtProtectedControlName]="questionForm.value.questionTitle"
>
  @for (
    option of getOptionsControls();
    track trackByOption(i, option);
    let last = $last;
    let i = $index
  ) {
    <ng-container formArrayName="contents">
      <div layout-horizontal layout-align-items-center padding-lr padding-tb-small>
        <div layout-vertical layout-flex-1>
          <rt-heading class="heading" margin-bottom-small-x>
            {{ option.value.title }}
          </rt-heading>
          <rt-heading class="subheading small">
            {{ option.value.hint }}
          </rt-heading>
        </div>
        <rt-interview-button-select [formControlName]="i" [horizontal]="true" padding-left-small>
        </rt-interview-button-select>
      </div>
      @if (!last) {
        <rt-divider></rt-divider>
      }
    </ng-container>
  }
</rt-interview-base-box>
